<template>
  <span>
    <v-tooltip bottom color="primary">
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          class="primary text--white"
          :disabled="selectedUsers.length == 0"
          v-on="{ ...tooltip }"
          @click="dialog = !dialog"
        >
          <v-icon left>mdi-plus</v-icon>Add Group
        </v-btn>
      </template>
      <span>Create a new user group.</span>
    </v-tooltip>

    <v-dialog v-model="dialog" width="60%">
      <v-card class="rounded-lg">
        <v-card-title color="white" primary-title>
          <v-icon color="primary">delete</v-icon>
          <span class="primary--text text--darken-3 title pl-2"
            >Create New User Group</span
          >
        </v-card-title>

        <v-card-text class="pt-4">
          <v-form v-model="form_is_valid">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="name"
                    dense
                    label="Group Name"
                    :rules="[rules.required]"
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="description"
                    dense
                    label="Group Description"
                    :rules="[rules.required]"
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  Select group contributor(s) [optional]:
                  <v-data-table
                    v-model="group_contributors"
                    :items="selectedUsers"
                    item-key="id"
                    show-select
                    dense
                    :headers="getTableHeaders()"
                    class="pt-2"
                  >
                  </v-data-table>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  Select group leader(s) [optional]:
                  <v-data-table
                    v-model="group_leaders"
                    :items="selectedUsers"
                    item-key="id"
                    show-select
                    dense
                    :headers="getTableHeaders()"
                    class="pt-2"
                  >
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">
            <v-icon left>close</v-icon> Cancel
          </v-btn>

          <v-btn
            color="primary"
            :disabled="!form_is_valid"
            @click="createGroup"
          >
            <v-icon left>mdi-plus</v-icon> Create Group</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import { actions as notifyActions } from '@/store/modules/notifications/types';

export default {
  props: {
    selectedUsers: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data: () => ({
    dialog: false,
    name: '',
    description: '',
    rules: {
      required: v => !!v || 'Required.',
    },
    form_is_valid: false,
    group_leaders: [],
    group_contributors: [],
  }),
  computed: {},
  watch: {
    dialog(dl) {
      if (dl) {
        this.group_leaders = [];
        this.group_contributors = [];
      }
    },
  },
  methods: {
    ...mapActions('notifications', {
      notifyError: notifyActions.NOTIFY_ERROR,
      notifySuccess: notifyActions.NOTIFY_SUCCESS,
    }),
    async createGroup() {
      const request_data = {
        name: this.name,
        description: this.description,
        user_ids: this.selectedUsers.map(u => u.id),
        leader_user_ids: this.group_leaders.map(u => u.id),
        contributor_user_ids: this.group_contributors.map(u => u.id),
      };
      axios
        .post('/api/groups', request_data)
        .then(({ _data }) => {
          this.$emit('groupCreated', true);
        })
        .catch(err => {
          if (err.response) {
            this.notifyError(
              'Create group request failed with status ' +
                err.status +
                ', error ' +
                err.data.error
            );
          } else {
            this.notifyError('Create group failed.');
          }
        });
      this.dialog = false;
    },
    dialogClicked() {
      this.dialog = !this.dialog;
    },
    getTableHeaders() {
      let headers = [
        {
          text: 'Name',
          value: 'name',
          class: 'text-subtitle-1 font-weight-bold',
        },
        {
          text: 'Email',
          value: 'email',
          class: 'text-subtitle-1 font-weight-bold',
        },
      ];
      return headers;
    },
  },
};
</script>

<style lang="scss" scoped></style>
